import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';

export class CustomValidator {
  static required(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    // Reject whitespace-only strings that Validators.required would otherwise accept.
    if (typeof value === 'string' && value.trim().length === 0) {
      return { msg: 'Required' };
    }
    return CustomValidator.customMessages(Validators.required, 'Required')(control);
  }

  static customMessages(validator: ValidatorFn, msg: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (validator(control)) {
        return { msg };
      }
      return null;
    };
  }

  static number(): ValidatorFn {
    return (control: FormControl): { [key: string]: any } => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null; // don't validate empty values to allow required validator to handle them
      }
      const num = parseFloat(value);
      if (isNaN(num)) {
        return { message: 'Value must be a number' };
      }
      return null;
    };
  }
  static pattern(pattern, message): ValidatorFn {
    return CustomValidator.customMessages(
      Validators.pattern(pattern),
      message
    )
  }

  static minRange(minRange: number): ValidatorFn {
    return CustomValidator.customMessages(
      Validators.min(minRange),
      `Value must be greater than this ${minRange}`
    );
  }

  static maxRange(maxRange: number): ValidatorFn {
    return CustomValidator.customMessages(
      Validators.min(maxRange),
      `Value must be greater than this ${maxRange}`
    );
  }

  static atLeastOneCheckBoxRequired(form: FormGroup): ValidationErrors | null {
    const checkbox = Object.values(form.controls);
    const isAnyChecked = checkbox.some(control => control.value);
    return isAnyChecked ? null : { atLeastOneRequired: true };
  }
  static rangeInBetween(minRange: number, maxRange: number): ValidatorFn {
    return (control: FormControl): { [key: string]: any } => {
      const controlValue = parseInt((control.value + '').trim(), 10);
      if (isNaN(controlValue)) {
        return null;
      }

      return controlValue >= minRange && controlValue <= maxRange
        ? null
        : {
            msgKey: 'clinicSetup.questionnaire.expiration.rangeInBetweenDays',
            msgParams: { min: minRange, max: maxRange }
          };
    };
  }
}
